import { Injectable, signal } from "@angular/core";
import { httpsCallable } from "firebase/functions";
import { functions } from "../app.component";
import { MatSnackBar } from "@angular/material/snack-bar";

export interface GetAddressResponse {
  street: string;
  houseNumber: string;
  postalCode: string;
  city: string;
  province?: string;
}

@Injectable({
  providedIn: 'root',
})
export class PostcodeApiService {
  fetchingAddress = signal(false);
  constructor(private snackBar: MatSnackBar) {}

  async getAddress(postalCode: string, houseNumber: string): Promise<GetAddressResponse | null> {
    this.fetchingAddress.set(true);
    try {
      const callable = httpsCallable(functions, 'httpGetAddressWithApi');
      const result: any = await callable({
        postal: postalCode.trim().toUpperCase().replace(/\s/g, ''),
        houseNumber: houseNumber.trim(),
      });

      if (!result.data || !result.data['street']) {
        this.snackBar.open(
          'De opgegeven postcode en het huisnummer horen niet bij een geldig adres.',
          'X',
          { duration: 5000 },
        );
        return null;
      }

      console.log(result.data);
      const addressResult: GetAddressResponse = {
        street: result.data['street'],
        houseNumber: result.data['houseNumber'],
        postalCode: result.data['postalCode'],
        city: result.data['city'],
        province: result.data['province'],
      };
      return addressResult;
    } catch (error) {
      console.error('Postcode API error:', error);
      this.snackBar.open(
        'De opgegeven postcode en het huisnummer horen niet bij een geldig adres.',
        'X',
        { duration: 5000 },
      );
      return null;
    } finally {
      this.fetchingAddress.set(false);
    }
  }
}